import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import SettingsContent from './SettingsContent'

class Settings extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <SettingsContent />
      </main>
    )
  }
}

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

Settings.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Settings) 


// WEBPACK FOOTER //
// ./src/components/pages/Settings/index.js